import { render } from "./CertificateDetail.vue?vue&type=template&id=d20409a2"
import script from "./CertificateDetail.vue?vue&type=script&lang=js"
export * from "./CertificateDetail.vue?vue&type=script&lang=js"
script.render = render

export default script